import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const label = theme => css`
  font-size: ${rem(19)};
  color: ${theme.color.info['900']};
  font-weight: ${theme.fontWeight.medium};
`

const box = theme => css`
  font-weight: ${theme.fontWeight.medium};
  font-size: ${theme.fontSize.large};
  background-color: ${theme.color.monochrome.white};
  min-height: ${rem(48)};
  width: 100%;
  border-radius: ${rem(6)};
  padding: ${rem(8)} ${rem(12)} ${rem(8)} ${rem(16)};
  display: flex;
  align-items: center;
  border: 1px solid ${theme.color.monochrome.medium};
  box-shadow: 0 ${rem(2)} ${rem(2)} 0
    rgba(${theme.color.monochrome.black_rgba}, 0.05);
`

const noticeMessage = theme => css`
  color: ${theme.color.monochrome.dark};
`

export const styles = {
  label,
  box,
  noticeMessage,
}
